import { z } from 'zod';
/** The maintenance banner staff set in the platform admin (docs/adr/0024). Its own module so the apps
 * that show it don't pull in the platform admin's contract. */
export const Maintenance = z.object({ message: z.string().trim().min(3).max(280), level: z.enum(['info', 'warning']) });
//# sourceMappingURL=notice.js.map